import {
  getNewKey,
  isEditableInstallment,
  sortInstallmentsByDate,
} from 'components/common/balance-adjustment';
import { Order } from 'components/pages/order-details';
import { InstallmentEditable } from 'components/registration/v2/types';
import { PendingPayment, PreviewLineItems } from 'hooks/postRegEditDrawer';
import { Adjustment, BalanceError } from './adjust-order-drawer';

export function getPendingPayment(
  previewLineItems: PreviewLineItems
): PendingPayment {
  if (!previewLineItems) {
    return null;
  }
  const installments = previewLineItems?.installments || [];
  let savedPaymentMethod = null;
  const editableInstallments = installments
    .filter(isEditableInstallment)
    .map((installment) => {
      if (installment.paymentMethod && !savedPaymentMethod) {
        savedPaymentMethod = installment.paymentMethod;
      }
      return {
        _key: getNewKey(),
        amount: installment.amount,
        status: installment.status,
        scheduledDate: installment.scheduledDate,
        originalDate: installment.scheduledDate,
        id: installment.id,
      } as InstallmentEditable;
    });
  editableInstallments.sort(sortInstallmentsByDate);
  const paidBalance = installments.reduce((acc, installment) => {
    if (installment.status === 'paid') {
      return acc + installment.amount;
    }
    return acc;
  }, 0);
  return {
    paidBalance,
    savedPaymentMethod,
    installments: editableInstallments,
  };
}

export function isSaveDisabled(
  balanceError: BalanceError,
  adjustment: Adjustment,
  order: Order,
  previewLoaded: boolean,
  accepted: boolean,
  isLoading: boolean
): boolean {
  if (
    Object.keys(balanceError.fieldErrors ?? {}).length ||
    balanceError.error
  ) {
    return true;
  }
  const { type: adjustmentType, amount } = adjustment;
  const netAmountChange =
    (parseFloat(amount) ?? 0) * (adjustmentType === 'reduce' ? -1 : 1);
  const netAmountRemaining = (order?.amountRemaining ?? 0) / 100;
  const newAmountResultIsNegative = netAmountRemaining + netAmountChange < 0;

  let isReduceAmountValid = true;

  let isAmountValid = false;
  switch (adjustmentType) {
    case 'payment_schedule': {
      isAmountValid = true;
      break;
    }
    case 'reduce': {
      if (newAmountResultIsNegative) {
        isReduceAmountValid = false;
      }
    }
    case 'add': {
      if (
        isReduceAmountValid &&
        amount !== undefined &&
        parseFloat(amount) >= 0.01
      )
        isAmountValid = true;
    }
  }

  return (
    !previewLoaded ||
    (previewLoaded && !accepted) ||
    !isAmountValid ||
    isLoading
  );
}
